import CountUp from "react-countup";

const PartnerCounters = ({ totalReferred = 0, totalDemat = 0, totalPartnerRewards = 0, averageRating = 0 }) => {
	return (
		<section id="counts" class="counts pb-2">
			<div class="container aos-init aos-animate mt-2" data-aos="fade-up">
				<div class="row">
					<div class="col-lg-3 col-md-6 my-2">
						<div class="count-box">
							<i class="fa fa-users"></i>
							<div>
								<strong>Total Referred</strong>
								<CountUp start={0} end={totalReferred} duration={2} />
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 my-2">
						<div class="count-box">
							<i class="fa fa-handshake-o" style={{ color: "#ee6c20" }}></i>
							<div>
								<strong>Total Demat</strong>
								<CountUp start={0} end={totalDemat} duration={2} />
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 my-2">
						<div class="count-box">
							{/* <i class="fa fa-calendar" style={{ color: "#15be56" }}></i> */}
							<span style={{ zoom: 0.15, position: 'relative', right: '100px' }}>
								<img src="assets/img/gt-logo.png" />
							</span>
							<div>
								<strong>Your Rewards</strong>
								<CountUp start={0} end={totalPartnerRewards} duration={2} />
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 my-2">
						<div class="count-box">
							<i class="fa fa-star" style={{ color: "#bb0852" }}></i>
							<div>
								<strong>Your Ratings</strong><small>(average)</small>
								<CountUp start={0} end={averageRating} duration={2} />
							</div>
						</div>
					</div>

				</div>
			</div>
		</section>
	)
}

export default PartnerCounters